export default __webpack_public_path__ + "src/dataset/galleries-691a-48ed9f.txt";